import * as React from 'react';
import { SyntheticEvent } from 'react';
import { cleanInput } from '../../ta-services/ta-utils';
import { TaUserData } from '../../ta-shared';

export type TaWelcomePageFormProps = {
	onInputChange: (key: string, value: string) => void;
	onFormSubmit: () => void;
	isButtonLoading: boolean;
	formValues: TaUserData;
};

export const TaWelcomePageForm = ({
	onInputChange,
	onFormSubmit,
	isButtonLoading,
	formValues,
}: TaWelcomePageFormProps) => {
	const handleInput = (e: SyntheticEvent) => {
		e.persist();
		const { name, value } = e.target as HTMLInputElement;
		onInputChange(name, cleanInput(value));
	};

	const handleSubmit = (e: SyntheticEvent) => {
		e.preventDefault();
		onFormSubmit();
	};

	const renderButtonContent = () => {
		return !isButtonLoading ? (
			'Next'
		) : (
			<div className='ta-welcome-page_loader'>
				<div />
				<div />
				<div />
				<div />
			</div>
		);
	};

	return (
		<form className='ta-welcome-page_form' onSubmit={handleSubmit}>
			<input
				className='ta-welcome-page_text-input'
				onChange={handleInput}
				placeholder='Full name'
				value={formValues.fullName}
				type='text'
				name='fullName'
				required={true}
			/>
			<input
				className='ta-welcome-page_text-input'
				onChange={handleInput}
				placeholder='Company name'
				value={formValues.company}
				type='text'
				name='company'
				required={true}
			/>
			<input
				className='ta-welcome-page_text-input'
				onChange={handleInput}
				placeholder='Enter your work email'
				value={formValues.email}
				type='email'
				name='email'
				required={true}
			/>
			<label className='ta-welcome-page_input-label'>
				<input
					type='checkbox'
					className='ta-welcome-page_checkbox'
					required={true}
				/>
				<div>
					I agree to the Privacy Policy including to WixAnswers.com
					using my contact details to contact me for marketing
					purposes.
				</div>
			</label>
			<button className='ta-welcome-page_button'>
				{renderButtonContent()}
			</button>
		</form>
	);
};
